import { render } from "./MyCardFooterButtonDelete.vue?vue&type=template&id=61e5468e"
import script from "./MyCardFooterButtonDelete.vue?vue&type=script&lang=js"
export * from "./MyCardFooterButtonDelete.vue?vue&type=script&lang=js"

import exportComponent from "/home/fluffypony/Projects/cards/cards-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__